<template>
    <van-field
        class="van-field-checkbox"
        v-model="vModel"
        :name="paramName"
        :required="required"
        :label="label"
        :rules="rules"
        :disabled="disabled"
        readonly
    >
        <template #extra >
            <van-checkbox-group
                v-model="lwwRadio"
                :disabled="disabled"
                direction="horizontal"
                @change="onChange"
            >
                <van-checkbox
                    v-for="item in options"
                    :shape="item.square || 'square'"
                    :key="item.value"
                    :name="item.value"
                    >{{ item.label }}</van-checkbox
                >
            </van-checkbox-group>
        </template>
    </van-field>
</template>
<script>
export default {
    props: {
        options: {
            type: Array,
            default: () => {
                return []
            }
        },
        rules: {
            type: Array,
            default: () => {
                return []
            }
        },
        disabled: {
            type: Boolean,
            default: false
        },
        required: {
            type: Boolean,
            default: false
        },
        customClass: {
            type: String,
            default: ''
        },
        initValue: {
            default: ''
        },
        label: {
            type: String,
            default: ''
        },
        paramName: {
            type: String,
            default: ''
        },
        defaultIndex: {
            type: Number,
            default: 0
        }
    },
    data() {
        const initValue = this.initValue || ''
        return {
            vModel: initValue,
            lwwRadio: initValue.split(',')
        }
    },
    watch: {
        initValue(newVal) {
            this.vModel = newVal
            this.lwwRadio = newVal.split(',')
        }
    },
    methods: {
        onChange(name) {
            this.vModel = name.join(",")
        }
    },
    mounted() {
        if (this.initValue === '' || this.initValue == undefined) {
            if (this.options.length > 0) {
                const value = this.options[this.defaultIndex].value
                this.lwwRadio = [value]
                this.vModel = value
            }
        }
    }
}
</script>
<style lang="less">
.van-field-checkbox {
    .van-cell__value.van-field__value{
        width: 0;
        flex: none;
    }
}
</style>
